// Types
import { LOCATION_DIALING_CODE_FAIL, LOCATION_DIALING_CODE_START, LOCATION_DIALING_CODE_SUCCESS } from "./types";
//Redux
import { getServicesErrorObj } from "../servicesDowntime/actions";
import { request } from "../session/actions";
// Utils
import { getAxiosDetails } from "../../../core/utils/GetBasicDetails/GetAxiosDetails";

export type DialingCodeAction = {
    type: string,
    payload?: any
};

export const getLocationDialingCodeRequestStart = () => ({
    type: LOCATION_DIALING_CODE_START
});

export const getLocationDialingCodeRequestFail = () => ({
    type: LOCATION_DIALING_CODE_FAIL
});

export const getLocationDialingCodeRequestSuccess = (payload: any) => ({
    type: LOCATION_DIALING_CODE_SUCCESS,
    payload
});

export const getLocationDialingCode = () => {
    return async (dispatch: Function) =>
        new Promise((resolve, reject) => {
            const headers = getAxiosDetails();
            dispatch(getLocationDialingCodeRequestStart());
            dispatch(
                request({
                    url: '/affiliate-portal/Location/locationDetails',
                    method: "GET",
                    headers: headers.headers,
                })
            ).then((response) => {
                dispatch(getLocationDialingCodeRequestSuccess(response.data));
                resolve(response);
            }).catch((error) => {
                dispatch(getLocationDialingCodeRequestFail());
                dispatch(getServicesErrorObj(error));
                reject(error);

            });;
        });
};